import { render, staticRenderFns } from "./StatsCardOrder.vue?vue&type=template&id=a9ff4364&scoped=true"
import script from "./StatsCardOrder.vue?vue&type=script&lang=js"
export * from "./StatsCardOrder.vue?vue&type=script&lang=js"
import style0 from "./StatsCardOrder.vue?vue&type=style&index=0&id=a9ff4364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ff4364",
  null
  
)

export default component.exports